import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Attendance from '@/pages/Attendance';
import AddressBook from '@/pages/AddressBook';
import CADOrders from '@/pages/CADOrders';
import GoldCalculator from '@/pages/GoldCalculator';
import LossCal from '@/pages/LossCal';
import Estimate from '@/pages/Estimate';
import Defaults from '@/pages/Defaults';
import OrderStatus from '@/pages/OrderStatus';
import TodoList from '@/pages/TodoList';
import Remainder from '@/pages/Remainder';
import MonthlyChecklist from '@/pages/MonthlyChecklist';
import WeeklyChecklist from '@/pages/WeeklyChecklist';
import DailyChecklist from '@/pages/DailyChecklist';
import StocksIndent from '@/pages/StocksIndent';
import AdminPanel from '@/pages/AdminPanel';
import Reports from '@/pages/Reports';
import Login from '@/pages/Login';

// Protected Route wrapper component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function AppRoutes() {
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={
        !isAuthenticated ? <Login /> : <Navigate to="/" replace />
      } />
      
      {/* Protected routes */}
      <Route element={
        <ProtectedRoute>
          <Layout user={user} onLogout={logout} />
        </ProtectedRoute>
      }>
        <Route path="/" element={<Home user={user} />} />
        <Route path="/attendance" element={<Attendance user={user} />} />
        <Route path="/address-book" element={<AddressBook user={user} />} />
        <Route path="/cad-orders" element={<CADOrders user={user} />} />
        <Route path="/gold-calculator" element={<GoldCalculator user={user} />} />
        <Route path="/loss-cal" element={<LossCal user={user} />} />
        <Route path="/estimate" element={<Estimate user={user} />} />
        <Route path="/defaults" element={<Defaults user={user} />} />
        <Route path="/order-status" element={<OrderStatus user={user} />} />
        <Route path="/todo-list" element={<TodoList user={user} />} />
        <Route path="/remainder" element={<Remainder user={user} />} />
        <Route path="/monthly-checklist" element={<MonthlyChecklist user={user} />} />
        <Route path="/weekly-checklist" element={<WeeklyChecklist user={user} />} />
        <Route path="/daily-checklist" element={<DailyChecklist user={user} />} />
        <Route path="/stocks-indent" element={<StocksIndent user={user} />} />
        <Route path="/reports" element={<Reports user={user} />} />
        <Route path="/admin" element={<AdminPanel user={user} />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;